import React, { useState } from "react";
import ReactModal from "react-modal";
import { ROUTE } from "../../route/Route";
import { Console } from "console";

ReactModal.setAppElement("#root");

export const ShareTestModal = ({
  setShareModal,
  shareModal,
  selectedTest,
  getSelectTest,
}: any) => {
  const [copied, setCopied] = useState(false);
  const closeModal = () => setShareModal(false);

  // Add console log for selectedTest
  console.log("selectedTest", selectedTest);

  const handleCopy = () => {
    navigator.clipboard.writeText(getSelectTest);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleWhatsAppShare = () => {

    const name = selectedTest?.TestName || selectedTest?.PackageName || "";
    const code = selectedTest?.TestCode || selectedTest?.PackageCode || "";

    const shareText = `Check out this test: ${
      name}\nTest Code: ${code}\nDepartment: ${selectedTest?.Department || ""}\nMRP: ${selectedTest?.MRP || ""}\nSample Type: ${selectedTest?.SampleType || ""}\nTemperature: ${selectedTest?.Temperature || ""}\nSample Remarks: ${selectedTest?.SampleRemarks || ""}\nCut-Off Time: ${selectedTest?.CutOffTime || ""}\nReport TAT: ${selectedTest?.Days}\nTest Category: ${selectedTest?.TestCategory || ""}\nBilling Category: ${selectedTest?.BillingCategory || ""}\nSchedule: ${selectedTest?.Schedule || ""}\nComponents: ${selectedTest?.Components?.map((c: any) => c.title).join(", ") || ""}\nLink: ${getSelectTest}`;

    const encodedText = encodeURIComponent(shareText);
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    if (isMobile) {
      const nativeUrl = `whatsapp://send?text=${encodedText}`;
      const webUrl = `https://api.whatsapp.com/send?text=${encodedText}`;

      const link = document.createElement("a");
      link.href = nativeUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);

      const timeout = setTimeout(() => {
        document.body.removeChild(link);
        window.open(webUrl, "_blank");
      }, 250);

      link.click();

      link.addEventListener("click", () => {
        clearTimeout(timeout);
        document.body.removeChild(link);
      });
    } else {
      window.open(
        `https://web.whatsapp.com/send?text=${encodedText}`,
        "_blank"
      );
    }
  };

  return (
    <div>
      <ReactModal
        isOpen={shareModal}
        onRequestClose={closeModal}
        className="my_acc_modal acc_modal_content share-modal-width"
        overlayClassName="my_acc_overlay"
        contentLabel="Share Modal"
        ariaHideApp={false}
      >
        <div className="">
          <div className="cross_button">
            <img
              src="/assets/img/my-profile/cross.png"
              alt="Close modal"
              className="cursor-pointer"
              onClick={closeModal}
            />
          </div>

          <h2 className="text-lg font-semibold mb-4">Share Via</h2>
          <div className="modal-body text-center">
            <p style={{ fontSize: "16px" }}>Share this link via</p>
            <div className="d-flex justify-content-between gap-3 mb-3 mt-3">
              <a
                onClick={handleWhatsAppShare}
                className="share-button"
                aria-label="Share via WhatsApp"
              >
                <img
                  src="/assets/img/whatsapp-share-icon.png"
                  alt="WhatsApp share icon"
                  className="share-icons"
                />
                <p>WhatsApp</p>
              </a>
              <a
                href={`sms:?body=${encodeURIComponent(getSelectTest)}`}
                className="share-button"
              >
                <img
                  src="/assets/img/message-share-icon.png"
                  alt="Message share icon"
                  className="share-icons"
                />
                <p>Message</p>
              </a>
              <a
                href={`mailto:?subject=Check this out&body=${encodeURIComponent(
                  `Check out this test: ${
                    selectedTest?.TestName || ""
                  }\n${getSelectTest}`
                )}`}
                className="share-button"
              >
                <img
                  src="/assets/img/gmail-share-logo.png"
                  alt="Email share icon"
                  className="mail-share-icons"
                />
                <p style={{ marginTop: "5px" }}>Mail</p>
              </a>
            </div>
            <p className="mb-3" style={{ fontSize: "16px" }}>
              Or copy link
            </p>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={getSelectTest}
                readOnly
                aria-label="Shareable link"
              />
              <button
                className="copy-link-button"
                onClick={handleCopy}
                aria-label="Copy link to clipboard"
              >
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};
